import type { Me } from "./session";

/** The companies a staff member can open the console in. */
export const adminCompanies = (me: Me) => me.companies.filter((c) => c.apps.includes("admin"));

const AUTH_PAGES = ["/sign-in", "/set-password", "/choose-company"];

/**
 * A `next` path is only followed inside the console: a relative path, not protocol-relative
 * ("//evil.example"), and not back to a sign-in step.
 */
export function safeNext(next: string | undefined): string | undefined {
  if (!next?.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return undefined;
  const path = next.split(/[?#]/)[0];
  return AUTH_PAGES.includes(path) ? undefined : next;
}

/** Where a session goes: sign in, choose a company, or the page it asked for. */
export function landingFor(me: Me | null, next?: string): string {
  const target = safeNext(next);
  if (!me) return "/sign-in";
  // the page asked for still opens once a company is chosen
  if (!me.active_company)
    return target ? `/choose-company?${new URLSearchParams({ next: target })}` : "/choose-company";
  return target ?? "/";
}
